export default __webpack_public_path__ + "static/media/rhenus-vlc.acec9093.svg";